

































import { createComponent, ref, onMounted, watch, computed } from '@vue/composition-api'
import { menuList, IMenuItem, FilePower } from '../constant'
import isElectron from 'is-electron'
import { isEmpty } from 'lodash'
export default createComponent({
    setup(props, setupContext) {
        const activeMenuId = ref<string>('/public/')
        watch(
            () => setupContext.root.$route,
            route => {
                activeMenuId.value = route.path
            },
            {
                lazy: true,
            }
        )
        const userDetails = computed(() => setupContext.root.$store.state.userDetails)
        const isShowAccessManage = computed((): boolean => {
            if (isEmpty(userDetails.value)) return false
            return !(
                isEmpty(userDetails.value.manageTopIds) &&
                isEmpty(
                    Object.values(userDetails.value.powerMap).filter(
                        powers => Array.isArray(powers) && powers.includes(FilePower['APPROVAL'])
                    )
                )
            )
        })
        const navList = computed((): IMenuItem[] => {
            if (isShowAccessManage.value) {
                return !isElectron() ? menuList.filter(item => !item.isClient) : menuList
            } else {
                return !isElectron()
                    ? menuList.filter(item => !item.isClient && !item.hasManageTopIds)
                    : menuList.filter(item => !item.hasManageTopIds)
            }
        })
        onMounted(() => {
            // if (isElectron()) {
            //     navList.value = menuList
            // } else {
            //     navList.value = menuList.filter(item => {
            //         return !item.isClient
            //     })
            // }
            const currentRoute = setupContext.root.$router.currentRoute
            activeMenuId.value = currentRoute.path
        })
        return {
            activeMenuId,
            navList,
        }
    },
})
